import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const ZOOM = { initial: { opacity: 0, scale: 1.08 }, whileInView: { opacity: 1, scale: 1 }, viewport: { once: true, margin: "-40px" }, transition: { duration: 1.4, ease: EASE } };

export const ZoomImg = (props) => <motion.img {...ZOOM} {...props} />;
export const ZoomWrap = ({ children, className = "" }) => <motion.div {...ZOOM} className={className}>{children}</motion.div>;

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ eyebrow, title, children, testId }) => (
  <section className="container-x pb-12 pt-16 sm:pt-24" data-testid={testId}>
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="mt-4 max-w-4xl text-4xl font-black leading-[1.05] tracking-tight text-forest sm:text-5xl lg:text-6xl">{title}</h1>
      {children && <div className="mt-6 max-w-2xl text-base font-medium leading-relaxed text-moss md:text-lg">{children}</div>}
    </Reveal>
  </section>
);
